/**
 * Class to extend and modify the size chart popup functionality.
 */
class ExtendSizeChart {
	/**
	 * Constructor to initialize instance variables.
	 */
	constructor() {
		this.overlay = null;
		this.getChart = null;
		this.existingButton = null;
		this.isButtonInitialized = false;
	}

	/**
	 * Method to initialize the component functionality.
	 */
	init() {
		this.initializeElements();
		this.moveOverlayToEndOfDocument();
		this.enhanceShowPopupButton();
	}

	/**
	 * Initialize common elements used in multiple methods.
	 */
	initializeElements() {
		this.existingButton = document.querySelector( '.kapsc_pop_btn' );

		if ( ! this.existingButton ) {
			return;
		}

		this.overlay = document.querySelector( '.kapsc-popup-overlay' );
		this.getChart = document.getElementById( 'myPopup-' + this.existingButton.value );
	}

	/**
	 * Method to move the '.kapsc_hid_OL' element to the end of the document and rearrange content to match Yith plugin.
	 */
	moveOverlayToEndOfDocument() {
		if ( this.overlay && this.getChart ) {
			const popuptext = this.overlay.querySelector( '.popuptext' );
			const popupContentDiv = this.overlay.querySelector( 'div.popup-content' );
			const table = this.overlay.querySelector( 'table.tab_bor' );

			if ( ! popuptext ) {
				return;
			}

			if ( popupContentDiv && table ) {
				// Detach the elements
				popupContentDiv.remove();
				table.remove();

				// Wrap table in a div and reattach in the desired order
				const tableWrapper = document.createElement( 'div' );
				tableWrapper.className = 'table-wrapper';
				tableWrapper.appendChild( table );
				popuptext.appendChild( tableWrapper );
				popuptext.appendChild( popupContentDiv );
			}

			// Create H2 element and append it to getChart
			const h2 = document.createElement( 'h2' );
			h2.textContent = this.existingButton.textContent;
			this.getChart.insertBefore( h2, this.getChart.firstChild );

			// Move the entire overlay to the end of the document body
			document.body.appendChild( this.overlay );
		}
	}

	/**
	 * Method to add a new button that shows the popup, placed next to the existing button.
	 */
	enhanceShowPopupButton() {
		if ( this.existingButton && this.overlay && this.getChart && ! this.isButtonInitialized ) {
			this.existingButton.removeAttribute( 'onclick' );

			this.existingButton.addEventListener( 'click', () => {
				this.overlay.style.display = 'block';
				this.overlay.classList.add( 'kapsc-popup-overlay' );
				this.getChart.style.display = 'block';

				const span = this.getChart.querySelector( '.close' );
				span.addEventListener( 'click', () => {
					this.getChart.style.display = 'none';
					this.overlay.classList.remove( 'kapsc-popup-overlay' );
					this.overlay.style.background = '';
				} );

				window.addEventListener( 'click', event => {
					if ( event.target === this.overlay ) {
						this.getChart.style.display = 'none';
						this.overlay.classList.remove( 'kapsc-popup-overlay' );
						this.overlay.style.background = '';
					}
				} );
			} );

			// Mark the button as initialized to avoid attaching multiple listeners
			this.isButtonInitialized = true;
		}
	}
}

// Export the class
export default ExtendSizeChart;
